import { Outlet, createRootRoute } from '@tanstack/react-router';
import { NotFound, RootError } from '@/shared/components/route-states';

export const Route = createRootRoute({
  component: Outlet,
  errorComponent: RootError,
  notFoundComponent: NotFound,
});
